import api from './axios';

export const profileApi = {
  // Save a new avatar URL (URL must come from a valid S3 upload).
  setAvatar: ({ url }) => api.patch('/profile/avatar', { url }).then((r) => r.data),

  // Remove the current avatar
  removeAvatar: () => api.delete('/profile/avatar').then((r) => r.data),
};